module.exports = __webpack_public_path__ + "img/avatar_teacher3.4ecdd6fe.png";